import { type CustomFieldValueAttributes } from './generated/CustomFieldValueAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import ColorAttribute, {
  type IColorAttribute,
} from './concerns/ColorAttribute';

interface CustomFieldValue
  extends CustomFieldValueAttributes,
    IColorAttribute {}

@model
@ColorAttribute()
class CustomFieldValue extends ApplicationModel {
  // Start auto-generated
  static typename: 'CustomFieldValue' = 'CustomFieldValue';
  get typename(): 'CustomFieldValue' {
    return 'CustomFieldValue';
  }

  static internalTypename: 'CustomFieldValue' = 'CustomFieldValue';
  get internalTypename(): 'CustomFieldValue' {
    return 'CustomFieldValue';
  }

  static fields = {
    color: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    humanValue: attr({ readable: true }),
    id: attr({ readable: true }),
    key: attr({ readable: true }),
    position: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    value: attr({ readable: true, json: true }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    record: attr.belongsTo({
      readable: true,
      typename: [
        'Epic',
        'Feature',
        'Goal',
        'Idea',
        'Initiative',
        'Page',
        'Project',
        'Release',
        'Requirement',
        'SchedulingTeam',
        'Task',
      ],
    }),
    customFieldOptions: attr.hasMany({ readable: true }),
  };
  // End auto-generated

  /**
   * value is readonly in the graphql schema, but we need to be able to set it
   * for writing in the parent record
   */
  set value(newValue: any) {
    this.setAttribute('value', newValue);
  }
}

export default CustomFieldValue;
